<template>
  <NuxtLayout name="default">
    <div class="main-catgories-wrapper">
      <div class="all_categories" id="categoriesContainer">
        <div class="container">
          <!-- Section Title & Breadcrumb -->
          <div class="section_title">
            <h1>
              <span>الأقسام</span>
            </h1>
          </div>
          <Breadcrumb :isContainer="false" :paths="breadcrumbPaths" />

          <!-- Categories Grid -->
          <div class="row">
            <div v-for="category in categoriesStore.mainCategories" :key="category.id" class="col-md-4">
              <CategoryCard :category="category" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useCategoriesStore } from '@/store/categoriesStore'
import CategoryCard from '@/components/CategoryCard.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import { useHead } from '#imports'

const categoriesStore = useCategoriesStore()
const homeLabel = "الرئيسية"

onMounted(async () => {
  try {
    await categoriesStore.fetchMainCategories()
  } catch (error) {
    console.error('Error fetching main categories:', error)
  }
})

// Build breadcrumb paths for the Breadcrumb component.
const breadcrumbPaths = computed(() => {
  return [
    {
      label: 'الاقسام',
      link: ''
    }
  ]
})

const currentUrl = import.meta.client ? window.location.href : useRequestURL().href;


// Update head with title, meta, and the additional JSON‑LD for BreadcrumbList.
useHead({
  title: 'الأقسام',
  meta: [
    { property: 'og:title', content: `الأقسام | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
    { property: 'twitter:title', content: `الأقسام | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "الرئيسية",
            "item": "https://reviewapp.sa/"  // Replace with your actual home URL if different.
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "الاقسام",
            "item": currentUrl
          }
        ]
      })
    }
  ]
})
</script>

<style scoped>
.main-catgories-wrapper {
  background-size: 100%;
  background-repeat: no-repeat;
}

.all_categories {
  background-color: transparent;
  padding-top: 145px;
}

/* Add any page-specific styles here */
</style>
